import { render, staticRenderFns } from "./SaveButtonForPublisher.vue?vue&type=template&id=6ed39d42&scoped=true&"
import script from "./SaveButtonForPublisher.vue?vue&type=script&lang=js&"
export * from "./SaveButtonForPublisher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed39d42",
  null
  
)

export default component.exports